module.exports = __webpack_public_path__ + "media/images/product/p_r-75d00ca50e7c81bf32f993afdd923e1f.png";